module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "roundtable-settings-container relative mv3 center"
  }, [_c('walkthrough', {
    staticStyle: {
      "position": "absolute",
      "top": "16px",
      "right": "10px"
    },
    attrs: {
      "componentName": "onlineConfiguration"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap between-xs pv2"
  }, [_c('pl-button', {
    staticClass: "pl-no-margin",
    class: {
      selected: _vm.selected_tab === 'anonymitySettingsTab'
    },
    staticStyle: {
      "margin-left": "-12px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectTab('anonymitySettingsTab')
      }
    }
  }, [_vm._v("\n      Anonymity: " + _vm._s(_vm.getCurrentRT.enable_annonymous ? 'on' : 'off') + "\n      "), (_vm.selected_tab === 'anonymitySettingsTab') ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-no-margin",
    class: {
      selected: _vm.selected_tab === 'assessmentSettingsTab'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectTab('assessmentSettingsTab')
      }
    }
  }, [_vm._v("\n      Assessment: " + _vm._s(_vm.getCurrentRT.enable_grading ? 'on' : 'off') + "\n      "), (_vm.selected_tab === 'assessmentSettingsTab') ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _c('i', {
    staticClass: "fa fa-chevron-down"
  })]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-no-margin",
    class: {
      selected: _vm.selected_tab === 'guidanceQuestionsSettingsTab'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectTab('guidanceQuestionsSettingsTab')
      }
    }
  }, [_vm._v("\n      Peer Feedback\n      "), (_vm.selected_tab === 'guidanceQuestionsSettingsTab') ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _c('i', {
    staticClass: "fa fa-chevron-down"
  })])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "onboarding-roundtable-settings-bar"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade-up",
      "mode": "out-in"
    }
  }, [_c(_vm.selected_tab, {
    tag: "component",
    staticClass: "start-xs",
    on: {
      "closeTab": function($event) {
        _vm.selected_tab = null
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-013669f2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/pages/feed/roundtableSettingsInFeed.vue
// module id = 1343
// module chunks = 61